export function getdata() {
	var obj = {
		paginationSetting:{
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatasetting:[
			{
				title: "公司科目编码",
				prop: "subjectCode",
			},
			{
				title: "公司科目名称",
				prop: "subjectName",
			}
		],
		headData: [{
			title: "适用软件类别",
			custom: true,
			prop: "syrjlb",
			width: "100"
		},
		{
			title: "指标名称",
			prop: "zbmc",
			custom: true,
			width: 160,
			align: "left"
		},
		{
			title: "计算公式",
			prop: "jsgs",
			custom: true,
			width: "150",
			align: "left"
		},
		{
			title: "认定标准",
			children: [{
				title: "高新资质（销售收入）",
				children: [{
					title: "5千万至2亿",
					width: "90",
					custom: true,
					prop: "rdone"
				},
				{
					title: "2亿以上",
					width: "80",
					custom: true,
					prop: "rdtwo"
				}
				]
			},
			{
				title: "重软资质",
				custom: true,
				width: "80",
				prop: "rdthree"
			}
			]
		},

		{
			title: "公司代码",
			children: [{
				title: "bh001",
				prop: "gsdm1",
				width: "80",
			},]
		}
		],
		tableData: [{
			syrjlb: '通用',
			zbmc: '研发投入占销售收入比例',
			codeyf: 'YFTRZXSSRBL',
			jsgs: '指标值=研发投入（加计口径）/营业收入总额',
			rdone: '≥4%',
			rdtwo: '≥3%',
			rdthree: '≥7%/8%',
		}, {
			syrjlb: '嵌入式软件为主的公司',
			zbmc: '嵌入式软件收入(自主)占总收入比例',
			jsgs: '指标值=嵌入式软件收入（自主）/企业收入总额',
			codezz: 'QRSRJSRZZZZSRBL',
			rdone: '',
			rdtwo: '',
			rdthree: '≥40%',
		}, {
			syrjlb: '嵌入式软件为主的公司',
			zbmc: '嵌入式软件收入占总收入比例',
			jsgs: '指标值=嵌入式软件收入/企业收入总额',
			codez: 'QRSRJSRZZSRBL',
			rdone: '',
			rdtwo: '',
			rdthree: '≥45%',
		}, {
			syrjlb: '嵌入式软件为主的公司',
			zbmc: '公司总软件收入比例',
			jsgs: '指标值=软件总收入/企业收入总额',
			codegs: 'GSZSRJSRBL',
			rdone: '',
			rdtwo: '',
			rdthree: '≥50%',
		}, {
			syrjlb: '纯软件产品为主的公司',
			zbmc: '纯软件收入占比总收入比例',
			jsgs: '指标值=纯软件产品/企业收入总额',
			coderj: 'CRJSHZBZSRBL',
			rdone: '',
			rdtwo: '',
			rdthree: '≥55%',
		}],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatachoose: [{
			title: "序号",
			prop: "index",
			custom: true,
			width: "80"
		},
		{
			title: "公司代码",
			prop: "companyCode",
			width: "80"
		},
		{
			title: "纳税人（公司）名称",
			prop: "nsrmc",
			width: 160,
			align: "left"
		},
		{
			title: "纳税人识别号",
			prop: "nsrsbh",
			width: 160,
			align: "left"
		},
		],
		headDatasj: [{
			title: "",
			width: "170px",
			prop: "title",
			custom: true
		},

		]
	}
	return obj
}
